import React, { FunctionComponent, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SectionImageHeader from '../components/SectionImageHeader';

interface IProps {
  imageHeaderPath?: string;
  showImageHeader: boolean;
}

const Layout: FunctionComponent<IProps> = (props) => (
  <Fragment>
    <Navbar />
    {props.showImageHeader && (
      <SectionImageHeader imagePath={props.imageHeaderPath!} />
    )}
    {props.children}
    <Footer />
  </Fragment>
);

Layout.defaultProps = {
  showImageHeader: false
};

export default Layout;
